import { JSX } from 'react';
import { BrandCode } from '../../curriculum';
import { Item } from './datastore';
import { TrialLicenseGrantedEventResponse } from './response';

export type OnboardingTypeConfig = {
  getCurriculum: (brandCode: BrandCode) => Promise<Item[]>;
  grantLicenses: (
    items: Item[],
    userId: string,
    orgId: string,
    zipCode: string,
    brandCode: BrandCode
  ) => Promise<TrialLicenseGrantedEventResponse[]>;
  alreadyGrantedComponent: (redirectUrl?: string) => JSX.Element;
};

export type OnboardingType = 'trial' | 'preview';

type ConfigData = {
  type: OnboardingType;
  deactivated: boolean;
  background: string;
  subscriptionUrl?: string;
};

export const onboardingConfig: Record<BrandCode, ConfigData> = {
  BSFL: {
    type: 'trial',
    deactivated: false,
    background: 'linear-gradient(180deg, #f05a47 0%, #ff8979 100%)',
  },
  ETB: {
    type: 'trial',
    deactivated: false,
    background: 'linear-gradient(180deg, #CECECE 0%, #EAEAEA 100%)',
  },
  TGP: {
    type: 'trial',
    deactivated: false,
    background: 'linear-gradient(180deg, #1F2638 0%, #6375A5 100%)',
  },
  YOU: {
    type: 'trial',
    deactivated: false,
    background: 'linear-gradient(69.95deg, #EBF3F9 4.99%, #B0DDFC 69.32%)',
  },
  HYFI: {
    type: 'trial',
    deactivated: false,
    background: 'center / cover url("img/hyfi-onboarding-background.jpg") no-repeat',
    subscriptionUrl: 'https://myhyfi.com/learnmore',
  },
  VBS: {
    type: 'preview',
    deactivated: false,
    background: 'center / cover url("https://assets.lifeway.com/f_auto/GRID_VBS_PREVIEW_2550x1650_NoLogo") no-repeat',
  },
  HYFICHRISTMAS: {
    type: 'trial',
    deactivated: false,
    background: 'center / cover url("img/hyfi-christmas-preview/onboarding-background.jpg") no-repeat',
    subscriptionUrl: 'https://myhyfi.com',
  },
} satisfies Record<BrandCode, ConfigData>;
